"use strict";

import $ from "jquery";
import Swal from "sweetalert2";
import { lang, tr } from "../../utils/helpers";

const presencesSavedReport = {
  init() {
    $(".js-success").on("click", function () {
      Swal.fire({
        title: tr[lang].modal_success_thanks,
        text: tr[lang].modal_action_done,
        icon: "success",
      }).then(() => {
        window.location.href = "/minhas-acoes";
      });
    });
  },
};

export default presencesSavedReport;
